import { useRef, useState } from 'react';
import clsx from 'clsx';

import styles from './TextArea.module.css';

export interface TextAreaProps {
  /** Returns entered values as trimmed string */
  onChange: (value: string) => void;
  /** The label for the text area */
  label?: string;
  /** The max amount of allowed charecters in the text area */
  maxCharacters?: number;
}

export function TextArea({ onChange, label, maxCharacters = 0 }: TextAreaProps) {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const [characterCount, setCharacterCount] = useState(0);

  const handleInput = () => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = 'auto';
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;

      setCharacterCount(textAreaRef.current.value.length);
      onChange(textAreaRef.current.value.trim());
    }
  };

  return (
    <div className={styles['text-area__wrapper']}>
      <div className={styles['text-area__header']}>
        <span className={styles['text-area__label']}>{label}</span>
        {maxCharacters > 0 && (
          <div className={styles['text-area__word-count']}>
            <span className={clsx({ [styles['text-area__word-count--alert']]: characterCount === maxCharacters })}>
              {characterCount}
            </span>
            &nbsp;/&nbsp;{maxCharacters}
          </div>
        )}
      </div>

      <textarea
        ref={textAreaRef}
        className={styles['text-area']}
        maxLength={maxCharacters > 0 ? maxCharacters : undefined}
        onInput={handleInput}
      />
    </div>
  );
}
